import React from 'react';
import cx from 'classnames';

import styles from './styles.css';

export const Rhythm = ({
  children,
  vertical,
  center,
  right,
  justify,
  stretch,
  flexStart,
  style,
}: any) => (
  <div
    style={style}
    className={cx(
      (vertical && styles.vertical) || styles.horizontal,
      center && styles.center,
      justify && styles.justify,
      right && styles.right,
      stretch && styles.stretch,
      flexStart && styles.flexStart
    )}
  >
    {children}
  </div>
);
